import { connect } from 'react-redux';
import { getFormValues, getFormSyncErrors, change as formChange } from 'redux-form';
import _ from 'lodash';

import {
  getUiShowMode,
  getChangedYearMonths,
  uiChangeShowMode,
  uiChangeCalcMode,
  uiNotifyValueChanges,
  editRevision,
  recalculateRevision,
  resetRevision,
  getLastRevisionYearMonths
} from 'src/reducers/reports/notificationOfBaseAmountRevisions';
import RevisionItem from '../components/RevisionItem';

const mapStateToProps = (state, ownProps) => ({
  formRevision: getFormValues('revisions')(state).revisions[ownProps.revision.id],
  errors: _.get(getFormSyncErrors('revisions')(state), ['revisions', ownProps.revision.id]),
  showMode: getUiShowMode(state, ownProps.revision),
  changedYearMonths: getChangedYearMonths(state),
  lastRevisionYearMonths: getLastRevisionYearMonths(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  changeToEditMode: () => {
    dispatch(uiChangeShowMode({ revision: ownProps.revision, showMode: 'EDIT' }));
  },
  changeToManualCalcMode: () => {
    dispatch(uiChangeCalcMode({ revision: ownProps.revision, calcMode: 'MANUAL' }));
  },
  notifyValueChanges: () => {
    dispatch(uiNotifyValueChanges({ revision: ownProps.revision }));
  },
  cancel: () => {
    dispatch(formChange('revisions', `revisions.${ownProps.revision.id}`, ownProps.revision));
    dispatch(uiChangeShowMode({ revision: ownProps.revision, showMode: 'SHOW' }));
    dispatch(uiChangeCalcMode({ revision: ownProps.revision, calcMode: 'AUTO' }));
  },
  save: () => {
    dispatch(editRevision(ownProps.revision.id));
  },
  recalculate: (autoCalc = true) => {
    dispatch(recalculateRevision(ownProps.revision.id, autoCalc));
  },
  reset: () => {
    dispatch(resetRevision(ownProps.revision.id));
  },
  setFormField: (name, val) => {
    dispatch(formChange('revisions', `revisions.${ownProps.revision.id}.${name}`, val));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(RevisionItem);
